import api, { adminApiPrefix } from './Api';
import {
  Coupon,
  couponFromResponse,
  couponToUpsertRequest,
} from '../interfaces/Coupon/Coupon';
import {
  CouponSummary,
  couponSummaryFromResponse,
} from '../interfaces/Coupon/CouponSummary';
import {
  CouponFilter,
  couponFilterToParams,
} from '../interfaces/Coupon/CouponFilter';
import { PaginatedResponse } from '../interfaces/PaginatedResponse';

const couponsAdminApiPrefix = `${adminApiPrefix}/coupons`;

export const createCoupon = async (coupon: Coupon): Promise<CouponSummary> => {
  const response = await api.post(
    couponsAdminApiPrefix,
    couponToUpsertRequest(coupon),
  );

  return couponSummaryFromResponse(response.data?.data);
};

export const getCoupons = async (
  filter: CouponFilter,
): Promise<PaginatedResponse<CouponSummary>> => {
  const response = await api.get(couponsAdminApiPrefix, {
    params: couponFilterToParams(filter),
  });

  return {
    data: (response.data?.data ?? []).map((coupon: any) =>
      couponSummaryFromResponse(coupon),
    ),
    totalCount: response.data?.total_count ?? 0,
  };
};

export const getCoupon = async (id: number): Promise<Coupon> => {
  const response = await api.get(`${couponsAdminApiPrefix}/${id}`);

  return couponFromResponse(response.data?.data);
};

export const updateCoupon = async (coupon: Coupon): Promise<void> =>
  api.put(
    `${couponsAdminApiPrefix}/${coupon.id}`,
    couponToUpsertRequest(coupon),
  );

export const deleteCoupon = async (id: number): Promise<void> =>
  api.delete(`${couponsAdminApiPrefix}/${id}`);
